import type { SVGAttributes } from 'react';

export const ArrowLeftIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="10"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 14 10"
      {...props}
    >
      <path
        d="M5.2937 9.71143L0.582031 4.99997L5.2937 0.288513L6.17182 1.19226L2.98911 4.37497H13.4187V5.62497H2.98911L6.17182 8.80768L5.2937 9.71143Z"
        fill="currentColor"
      />
    </svg>
  );
};
